import { Icon } from "@iconify/react";

const navConfig = [
  {
    id: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: (color) => (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 16C1 14.4596 1 13.6893 1.34673 13.1235C1.54074 12.8069 1.80693 12.5407 2.12353 12.3467C2.68934 12 3.45956 12 5 12C6.54044 12 7.31066 12 7.87647 12.3467C8.19307 12.5407 8.45926 12.8069 8.65327 13.1235C9 13.6893 9 14.4596 9 16C9 17.5404 9 18.3107 8.65327 18.8765C8.45926 19.1931 8.19307 19.4593 7.87647 19.6533C7.31066 20 6.54044 20 5 20C3.45956 20 2.68934 20 2.12353 19.6533C1.80693 19.4593 1.54074 19.1931 1.34673 18.8765C1 18.3107 1 17.5404 1 16Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M1 5C1 3.45956 1 2.68934 1.34673 2.12353C1.54074 1.80693 1.80693 1.54074 2.12353 1.34673C2.68934 1 3.45956 1 5 1C6.54044 1 7.31066 1 7.87647 1.34673C8.19307 1.54074 8.45926 1.80693 8.65327 2.12353C9 2.68934 9 3.45956 9 5C9 6.54044 9 7.31066 8.65327 7.87647C8.45926 8.19307 8.19307 8.45926 7.87647 8.65327C7.31066 9 6.54044 9 5 9C3.45956 9 2.68934 9 2.12353 8.65327C1.80693 8.45926 1.54074 8.19307 1.34673 7.87647C1 7.31066 1 6.54044 1 5Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M12 5C12 3.45956 12 2.68934 12.3467 2.12353C12.5407 1.80693 12.8069 1.54074 13.1235 1.34673C13.6893 1 14.4596 1 16 1C17.5404 1 18.3107 1 18.8765 1.34673C19.1931 1.54074 19.4593 1.80693 19.6533 2.12353C20 2.68934 20 3.45956 20 5C20 6.54044 20 7.31066 19.6533 7.87647C19.4593 8.19307 19.1931 8.45926 18.8765 8.65327C18.3107 9 17.5404 9 16 9C14.4596 9 13.6893 9 13.1235 8.65327C12.8069 8.45926 12.5407 8.19307 12.3467 7.87647C12 7.31066 12 6.54044 12 5Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <circle cx="16" cy="16" r="4" stroke={color} strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    id: 2,
    title: "eSign",
    path: "/received",
    icon: (color) => (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 22C9.35984 22 10.6908 21.3926 12.0494 20.1778M12.0494 20.1778C13.2078 19.1419 14.3863 17.6643 15 15.7452C16.3333 11.5753 8.33333 15.7452 11 19.2201C11.3281 19.6476 11.6815 19.9601 12.0494 20.1778ZM12.0494 20.1778C13.6521 21.1259 15.5311 20.274 16.8041 19.2944C17.1932 18.995 17.3877 18.8453 17.5038 18.8919C17.62 18.9386 17.6878 19.2064 17.8236 19.7422C18.2581 21.4569 19.5415 22.841 21 20.6105"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 13L20 7.89072C20 6.17637 20 5.31919 19.732 4.63458C19.3013 3.53399 18.3902 2.66585 17.2352 2.25535C16.5168 2 15.6173 2 13.8182 2C10.6698 2 9.09563 2 7.83836 2.44685C5.81714 3.16523 4.22281 4.68448 3.46894 6.61052C3 7.80858 3 9.30864 3 12.3088L3 14.8859C3 17.9936 3 19.5474 3.8477 20.6265C4.09058 20.9356 4.37862 21.2101 4.70307 21.4416C5.07016 21.7034 5.48961 21.8804 6 22"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 12C3 10.159 4.49238 8.66667 6.33333 8.66667C6.99912 8.66667 7.78404 8.78333 8.43137 8.60988C9.00652 8.45576 9.45576 8.00652 9.60988 7.43136C9.78333 6.78404 9.66667 5.99912 9.66667 5.33333C9.66667 3.49238 11.1591 2 13 2"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    children: [
      {
        id: 21,
        title: "New eSign",
        path: "/esign/new-esign",
      },
      {
        id: 22,
        title: "Bulk eSign",
        path: "/esign/bulk-esign",
      },
      {
        id: 23,
        title: "Stamp Paper",
        path: "/esign/stamp-paper",
      },
      {
        id: 24,
        title: "Documents",
        path: "/esign/documents",
      },
      {
        id: 25,
        title: "Signers",
        path: "/esign/signers",
      },
      {
        id: 26,
        title: "Archive",
        path: "/esign/archive",
      },
      {
        id: 27,
        title: "Trash",
        path: "/esign/trash",
      },
    ],
  },
  {
    id: 3,
    title: "Workflow",
    path: "/workflow",
    icon: (color) => (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.25 4.58334C8.25 3.28698 8.25 2.6388 8.65273 2.23607C9.05546 1.83334 9.70364 1.83334 11 1.83334C12.2964 1.83334 12.9445 1.83334 13.3473 2.23607C13.75 2.6388 13.75 3.28698 13.75 4.58334C13.75 5.87971 13.75 6.52789 13.3473 6.93062C12.9445 7.33334 12.2964 7.33334 11 7.33334C9.70364 7.33334 9.05546 7.33334 8.65273 6.93062C8.25 6.52789 8.25 5.87971 8.25 4.58334Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M1.83333 17.4167C1.83333 16.1203 1.83333 15.4721 2.23606 15.0694C2.63879 14.6667 3.28697 14.6667 4.58333 14.6667C5.8797 14.6667 6.52788 14.6667 6.93061 15.0694C7.33333 15.4721 7.33333 16.1203 7.33333 17.4167C7.33333 18.713 7.33333 19.3612 6.93061 19.764C6.52788 20.1667 5.8797 20.1667 4.58333 20.1667C3.28697 20.1667 2.63879 20.1667 2.23606 19.764C1.83333 19.3612 1.83333 18.713 1.83333 17.4167Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M14.6667 17.4167C14.6667 16.1203 14.6667 15.4721 15.0694 15.0694C15.4721 14.6667 16.1203 14.6667 17.4167 14.6667C18.713 14.6667 19.3612 14.6667 19.7639 15.0694C20.1667 15.4721 20.1667 16.1203 20.1667 17.4167C20.1667 18.713 20.1667 19.3612 19.7639 19.764C19.3612 20.1667 18.713 20.1667 17.4167 20.1667C16.1203 20.1667 15.4721 20.1667 15.0694 19.764C14.6667 19.3612 14.6667 18.713 14.6667 17.4167Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M11 7.33334V8.25001M11 8.25001C11 9.10424 11 9.53135 11.1628 9.86826C11.3799 10.3175 11.7963 10.6744 12.3204 10.8605C12.7134 11 13.2117 11 14.2083 11C15.2049 11 15.7032 11 16.0963 11.1396C16.6204 11.3256 17.0368 11.6825 17.2539 12.1318C17.4167 12.4687 17.4167 12.8958 17.4167 13.75V14.6667M11 8.25001C11 9.10424 11 9.53135 10.8372 9.86826C10.6201 10.3175 10.2037 10.6744 9.67963 10.8605C9.28656 11 8.78826 11 7.79167 11C6.79507 11 6.29677 11 5.9037 11.1396C5.37962 11.3256 4.96323 11.6825 4.74615 12.1318C4.58333 12.4687 4.58333 12.8958 4.58333 13.75V14.6667"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    children: [
      {
        id: 31,
        title: "Workflow list",
        path: "/workflow/workflow-list",
      },
      {
        id: 32,
        title: "Records",
        path: "/workflow/records",
      },
      {
        id: 33,
        title: "Wallet",
        path: "/workflow/wallet",
      },
    ],
  },
  {
    id: 4,
    title: "API Integration",
    path: "/api-integration",
    icon: (color) => (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.29167 11C2.29167 6.89484 2.29167 4.84227 3.56697 3.56696C4.84228 2.29166 6.89485 2.29166 11 2.29166C15.1051 2.29166 17.1577 2.29166 18.433 3.56696C19.7083 4.84227 19.7083 6.89484 19.7083 11C19.7083 15.1051 19.7083 17.1577 18.433 18.433C17.1577 19.7083 15.1051 19.7083 11 19.7083C6.89485 19.7083 4.84228 19.7083 3.56697 18.433C2.29167 17.1577 2.29167 15.1051 2.29167 11Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M5.5 12.375L6.875 8.25L8.59375 12.375M5.5 12.375L5.04167 13.75M5.5 12.375H8.59375M8.59375 12.375L9.16667 13.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4583 11V8.89167C11.4583 8.72105 11.4583 8.63574 11.4808 8.5667C11.5261 8.42717 11.6355 8.31777 11.775 8.27243C11.8441 8.25 11.9294 8.25 12.1 8.25H13.2917C14.0511 8.25 14.6667 8.86561 14.6667 9.625C14.6667 10.3844 14.0511 11 13.2917 11H11.4583ZM11.4583 11V13.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9583 8.25V13.75"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 5,
    title: "Our Products",
    path: "/our-products",
    icon: (color) => (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2796 3.10015L16.1129 4.06224C18.0853 5.09728 19.0714 5.61481 19.6191 6.54477C20.1667 7.47474 20.1667 8.63196 20.1667 10.9464V11.0536C20.1667 13.3681 20.1667 14.5253 19.6191 15.4552C19.0714 16.3852 18.0853 16.9027 16.1129 17.9378L14.2796 18.8999C12.6702 19.7444 11.8656 20.1667 11 20.1667C10.1344 20.1667 9.32976 19.7444 7.72043 18.8999L5.8871 17.9378C3.91474 16.9027 2.92856 16.3852 2.38095 15.4552C1.83333 14.5253 1.83333 13.3681 1.83333 11.0536V10.9464C1.83333 8.63196 1.83333 7.47474 2.38095 6.54477C2.92856 5.61481 3.91474 5.09728 5.8871 4.06223L7.72043 3.10015C9.32976 2.25561 10.1344 1.83334 11 1.83334C11.8656 1.83334 12.6702 2.25561 14.2796 3.10015Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M19.25 6.875L11 11M11 11L2.75 6.875M11 11V19.7083"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    id: 6,
    title: "Settings",
    path: "/settings",
    icon: (color) => (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.4837 6.53913L19.0313 5.75391C18.6891 5.16006 18.518 4.86314 18.2269 4.74474C17.9358 4.62634 17.6065 4.71977 16.9481 4.90662L15.8295 5.22168C15.4091 5.31862 14.9681 5.26363 14.5842 5.06641L14.2754 4.88823C13.9463 4.67741 13.6931 4.36657 13.5529 4.0012L13.2468 3.08693C13.0455 2.48191 12.9449 2.1794 12.7053 2.00637C12.4657 1.83334 12.1475 1.83334 11.511 1.83334H10.4891C9.85259 1.83334 9.53434 1.83334 9.29475 2.00637C9.05515 2.1794 8.95452 2.48191 8.75324 3.08693L8.44711 4.0012C8.30697 4.36657 8.05379 4.67741 7.72463 4.88823L7.41582 5.06641C7.03197 5.26363 6.59092 5.31862 6.17053 5.22168L5.05197 4.90662C4.3935 4.71977 4.06427 4.62634 3.77316 4.74474C3.48204 4.86314 3.31095 5.16006 2.96877 5.75391L2.51631 6.53913C2.19556 7.09577 2.03519 7.37409 2.06631 7.67038C2.09744 7.96666 2.31213 8.20543 2.74153 8.68296L3.68665 9.7396C3.91765 10.032 4.08165 10.5417 4.08165 10.9999C4.08165 11.4583 3.9177 11.9678 3.68667 12.2603L2.74153 13.317C2.31214 13.7945 2.09744 14.0333 2.06631 14.3296C2.03519 14.6258 2.19557 14.9042 2.51631 15.4608L2.96875 16.246L2.96876 16.246C3.31093 16.8398 3.48205 17.1368 3.77316 17.2552C4.06427 17.3736 4.39351 17.2802 5.05199 17.0933L6.17049 16.7782C6.59095 16.6813 7.03209 16.7363 7.41599 16.9336L7.72475 17.1118C8.05384 17.3226 8.30696 17.6334 8.44708 17.9987L8.75324 18.9131C8.95452 19.5181 9.05515 19.8206 9.29475 19.9936C9.53434 20.1667 9.85259 20.1667 10.4891 20.1667H11.511C12.1475 20.1667 12.4657 20.1667 12.7053 19.9936C12.9449 19.8206 13.0455 19.5181 13.2468 18.9131L13.553 17.9987C13.6931 17.6334 13.9462 17.3226 14.2753 17.1118L14.5841 16.9336C14.968 16.7363 15.4091 16.6813 15.8296 16.7782L16.9481 17.0933C17.6065 17.2802 17.9358 17.3736 18.2269 17.2552C18.518 17.1368 18.6891 16.8398 19.0313 16.246L19.0313 16.246L19.4837 15.4608C19.8045 14.9042 19.9649 14.6258 19.9337 14.3296C19.9026 14.0333 19.6879 13.7945 19.2585 13.317L18.3134 12.2603C18.0823 11.9678 17.9184 11.4583 17.9184 10.9999C17.9184 10.5417 18.0824 10.032 18.3134 9.7396L19.2585 8.68296C19.6879 8.20543 19.9026 7.96666 19.9337 7.67038C19.9649 7.37409 19.8045 7.09577 19.4837 6.53913Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M12.8902 10.5417L13.3486 10.0833C13.753 9.67888 13.9552 9.47669 14.2206 9.5606C14.486 9.64451 14.5279 9.88452 14.6118 10.3645C14.6479 10.5709 14.6667 10.7833 14.6667 11C14.6667 13.0251 13.025 14.6667 11 14.6667C10.5138 14.6667 10.0496 14.572 9.625 14.4001M9.16667 11.4905L8.66786 11.9893C8.2698 12.3874 8.07077 12.5864 7.80795 12.5068C7.54513 12.4272 7.4982 12.192 7.40432 11.7216C7.35776 11.4883 7.33333 11.247 7.33333 11C7.33333 8.97497 8.97496 7.33334 11 7.33334C11.4862 7.33334 11.9504 7.42799 12.375 7.59987"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export { navConfig };
